export const emailFormatValidationRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const hexColorCode = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
export const userNameRegex = /^[a-zA-Z0-9 \-._@+ÆæØøÅåÄäÖö]*$/;
export const userNameNotEmptyRegex = /^.*[\S].*$/;
